<script>
  let { children } = $props();
</script>

<div class="infobox-layout">
  {@render children?.()}
</div>

<style>
  .infobox-layout {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: var(--spacing-4);
  }
  @media screen and (max-width: 1020px) {
    .infobox-layout {
      grid-template-columns: 1fr;
    }
  }
</style>
